import Decimal from 'decimal.js';

import { PathsOf } from '@/types/subform';

export enum CashflowIncomeOrExpense {
  Expense = 'expense',
  Income = 'income',
}

export enum CashflowFrequency {
  OneTime = 'one time',
  Annual = 'annually',
}

export enum CashflowValueType {
  Dollar = 'dollar',
  Percent = 'percent',
}

export enum CashflowEndType {
  Year = 'year',
  TrustTermination = 'trust-termination',
  Death = 'death',
  DeathOther = 'death-other',
  BothDeaths = 'both-deaths',
}

export const BOTH_CLIENTS_SENTINEL = 'both' as string;

export interface CashflowDrawerFormShape {
  name: string;
  targetId: string;
  valueType: CashflowValueType;
  amount: Decimal | null;
  percentage: Decimal | null;
  growthRate: Decimal | null;
  frequency: CashflowFrequency;
  startYear: number;
  endType: CashflowEndType;
  endYear: number | null;
  endAtDeathClientProfileId: string;
  incomeOrExpense: CashflowIncomeOrExpense;
}

export type CashflowDrawerFormPaths = PathsOf<CashflowDrawerFormShape>;

export const CashflowDrawerDefaultValues: CashflowDrawerFormShape = {
  name: '',
  targetId: '',
  valueType: CashflowValueType.Dollar,
  amount: null,
  percentage: null,
  growthRate: new Decimal(0),
  frequency: CashflowFrequency.OneTime,
  startYear: new Date().getFullYear(),
  endType: CashflowEndType.Year,
  endYear: new Date().getFullYear(),
  endAtDeathClientProfileId: CashflowEndType.BothDeaths,
  incomeOrExpense: CashflowIncomeOrExpense.Income,
};
